/**
 * Renders a numeric weight as a whole-percent string.
 *
 * Risk Prioritization stores weights as numbers (0-100). The slider
 * redistribution math can introduce floating-point residue (e.g.
 * 50.00000000000007). We always display whole percentages.
 */
export function formatPercent(value: number | undefined | null): string {
  if (value === undefined || value === null || Number.isNaN(value)) return '0%'
  return `${Math.round(value)}%`
}
